import React, { Component } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { func, shape } from "prop-types";
import { actions as echeckActions, selectors as echeqSelectors } from "reducers/echecks";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";

const FORM_ID = "echecks.aval";

class AnulateAvalForm extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
        echeqsToDoActions: shape({}).isRequired,
    };

    render() {
        const { handleSubmit, echeqsToDoActions } = this.props;
        let title;
        if (echeqsToDoActions?.action === "AVAL-ANULATE") {
            title = "echeck.anulate.reason";
        }
        if (echeqsToDoActions?.action === "AVAL-REPUDIATE") {
            title = "echeq.repudiate.aval.echeq";
        }

        return (
            <div className="container">
                <I18n id={title} component="h2" />
                <Form
                    className="above-the-fold"
                    onSubmit={(e) => {
                        handleSubmit(e);
                        e.stopPropagation();
                    }}>
                    <Field
                        component={TextField}
                        name="motive"
                        type="text"
                        hidePlaceholder
                        idForm={FORM_ID}
                        maxLength={100}
                    />
                    <Button type="submit" className="btn-primary" label="global.add" />
                </Form>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    echeqsToDoActions: echeqSelectors.getEcheqsToDoActions(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ motive: "" }),
        validationSchema: () =>
            Yup.object().shape({
                motive: Yup.string().required(i18n.get("global.error.required")),
            }),
        handleSubmit: (filters, formikBag) => {
            const { dispatch } = formikBag.props;
            dispatch(echeckActions.setEcheqsSpecialAttribute(filters.motive));
            dispatch(push("/echecks/aval/actions/sumary"));
        },
    }),
)(AnulateAvalForm);
